import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StatusService {
  private statusSubject = new BehaviorSubject<string>('ok'); // Valor por defecto
  status$ = this.statusSubject.asObservable();

  setStatus(status: string) {
    this.statusSubject.next(status);
  }
}
